import { render, staticRenderFns } from "./OriginalImagesContent.vue?vue&type=template&id=bec31160"
import script from "./OriginalImagesContent.vue?vue&type=script&lang=js"
export * from "./OriginalImagesContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports